import React from 'react';
import './Contact.css';
import { useState } from 'react';
import emailjs from '@emailjs/browser';

const Contact = () => {

    {/*const [isSubmitting, setIsSubmitting] = useState(false);
    const [stateMessage, setStateMessage] = useState(null);

    const sendEmail = (e) => {
        e.persist();
        e.preventDefault();
        setIsSubmitting(true);

        emailjs
            .sendForm(
                process.env.REACT_APP_SERVICE_ID,
                process.env.REACT_APP_TEMPLATE_ID,
                e.target,
                process.env.REACT_APP_PUBLIC_KEY
            )
            .then(
                (result) => {
                    setStateMessage('Message sent!');
                    setIsSubmitting(false);
                    setTimeout( () => {
                        setStateMessage(null);
                    }, 5000);
                },
                (error) => {
                    setStateMessage("Something went wrong, please try again later");
                    setIsSubmitting(false);
                    setTimeout( () => {
                        setStateMessage(null);
                    }, 5000);
                }
            );
        e.target.reset();
    }*/}

    return(
        <section className='contact-section' id="contact">
            <div className='contact-form-container'>
                <h2>Kontaktieren Sie uns</h2>
                <form className='contact-form' action="https://formsubmit.co/info@delta-tank.de" method="POST">

                    <div className='form-group'>
                        <label htmlFor='name'>Name <span className='star'>*</span></label>
                        <input type='text' id='name' name='name' required />
                    </div>

                    <div className='form-group'>
                        <label htmlFor='email'>E-Mail Adresse <span className='star'>*</span></label>
                        <input type='email' id='email' name='email' required />
                    </div>

                    <div className="form-group">
                        <label htmlFor="phone">Telefonnummer</label>
                        <input type="tel" id="phone" name="phone" />
                    </div>

                    <div className="form-group">
                        <label htmlFor="message">Nachricht</label>
                        <textarea id="message" name="message" rows="5"></textarea>
                    </div>

                    <div className="checkbox-group">
                        <input type="checkbox" id="consent" name="consent" required />
                        <label htmlFor="consent">
                            Ich erlaube dieser Website, meine Daten zu speichern, damit sie auf meine Anfrage antworten können <span className='star'>*</span>
                        </label>
                    </div>

                    <button type="submit" className="submit-button">Absenden</button>
                </form>
            </div>

            <div className='contact-info-container'>
                <h2>Unsere Adresse</h2>
                <div className='map'>
                    <iframe 
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2482.0451391714405!2d7.450717876286788!3d51.53073190899898!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47b919f624f431a3%3A0x6ee097064080b3f3!2sKleiststra%C3%9Fe%2012%2C%2044147%20Dortmund!5e0!3m2!1sen!2sde!4v1726402668401!5m2!1sen!2sde"
                        width="100%"
                        height="250"
                        style={{border: 0}}
                        allowFullScreen=""
                        loading='lazy'
                        title='Company Location'>
                    </iframe>

                </div>
                <p><strong>Email: </strong> info@delta-tank.de</p>
                <p><strong>Adresse: </strong><br />DELTA Tank GmbH <br></br>Kleiststr. 12, 44147 Dortmund</p>
                <p><strong>Öffnungszeiten:</strong><br />Montag - Donnerstag: 08:00 - 17:00 <br />Freitag: 08:00 - 13:00<br />Samestag und Sonntag: Geschlossen</p>
            </div>

        </section>
    );
};

export default Contact;